import React from 'react';
import { TItemsTab } from 'shared/types/types';
import { RolesUser } from 'shared/enums';
import { useAppDispatch, useAppSelector } from 'app/store';
import { Button, Tabs } from 'antd';
import { viewerModel } from 'entities/viewer';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { RvdStatuses } from 'shared/enums/rvd';
import { rvdActions } from 'entities/rvd/model/Rvd';
import { PICKER_DATE_MASK } from 'shared/constants';
import { TRvdGetResponse } from 'shared/types/rvd.types';
import { useTabsNavigate } from 'shared/hooks';
import { configTabs } from 'shared/helpers/utils';
import { uiModel } from 'entities/ui';
import RvdPull from './rvdPull/RvdPull';
import RvdArchive from './rvdArchive/RvdArchive';

import style from './index.module.scss';
import RvdSubstitutions from './rvdSubstitutions/RvdSubstitutions';
import RvdSubstitutionsArchive from './rvdSubstitutionsArchive/RvdSubstitutionsArchive';
import RvdInProgress from './rvdInProgress/RvdInProgress';

export enum RvdTabs {
  my = 'my',
  new = 'new',
  myArchive = 'myArchive',
  otherArchive = 'otherArchive',
  other = 'other',
}

const HolidayWork = () => {
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const { active } = useAppSelector(uiModel.Tabs.selectors.selectTabs);

  const [activeTab, handler] = useTabsNavigate(
    'rvd',
    (Object.values(RvdTabs).includes(active as RvdTabs) && active) || 'new',
  );
  const dispatch = useAppDispatch();

  const onCreateButtonClick = () => {
    const rvd: TRvdGetResponse = {
      id: Date.now(),
      created: moment().format(PICKER_DATE_MASK),
      count: 0,
      status: RvdStatuses.NOT_LOADED_CPRODUCT,
      employees: [],
      docSignatory: '',
    };
    dispatch(rvdActions.setCurrent(rvd));
  };

  const itemsTab: TItemsTab = [
    {
      label: 'Общий список заявок',
      key: 'new',
      children: <RvdPull />,
      role: [RolesUser.HRDirector, RolesUser.SecondLine],
    },
    {
      label: 'Подчинённые',
      key: 'other',
      children: <RvdSubstitutions />,
      role: [RolesUser.HRDirector, RolesUser.SecondLine],
    },
    {
      label: 'В работе',
      key: 'my',
      children: <RvdInProgress />,
      role: [RolesUser.HRDirector, RolesUser.SecondLine],
    },
    {
      label: 'Архив',
      key: 'myArchive',
      children: <RvdArchive />,
      role: [RolesUser.HRDirector, RolesUser.SecondLine],
    },
    {
      label: 'Архив подчиненных',
      key: 'otherArchive',
      children: <RvdSubstitutionsArchive />,
      role: [RolesUser.HRDirector, RolesUser.SecondLine],
    },
  ];
  const tabPane = configTabs(role, itemsTab);

  return (
    <>
      <div className={style.buttons}>
        <h3 className={style.title}>Работа в выходной день</h3>
        <Link to="/rvd/new">
          <Button type="primary" onClick={onCreateButtonClick}>
            Добавить заявку
          </Button>
        </Link>
      </div>

      <div className={style.wrap}>
        {/* To do: задать роли! */}
        {role && <Tabs activeKey={activeTab} onChange={handler} destroyInactiveTabPane items={tabPane}></Tabs>}
      </div>
    </>
  );
};

export default HolidayWork;
